import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

// 新增充账
export function addBalanceAPI(data) {
    return http({
        url: "/admin/finance/order/balance/add",
        method: "post",
        data,
    });
}

// 订单信息
export function getOrderInfoAPI(params) {
    return http({
        url: "/admin/order/info",
        method: "get",
        params,
    });
}

// 充账列表
export function getBalanceLogListAPI(params) {
  return http({
    url: "/admin/finance/order/balance-log/page",
    method: "get",
    params,
  });
}

// 充账列表导出
export function exportBalanceLogAPI(data) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/finance/order/balance-log/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then(async (res) => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      let filename = `充账记录${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch((error) => {
      hideScreenLoading();
      console.log(error);
    });
}
